module.exports = __webpack_public_path__ + "static/media/line_01.a2056a5d.png";